export default {
  state: {
    bulkUpdate: false,
    mobileMessage:  window.screen.width < 450,
    onboarding: false,
  },

  mutations: {
    update(state: any, {name, scope}: any) {
      state[name] = scope;
    },

    toggle(state: any, name: any) {
      state[name] = !state[name];
    },
  },

  actions: {
    showModal({commit}: any, name: string) {
      commit('update', {
        name,
        scope: true,
      });
    },

    hideModal({commit}: any, name: string) {
      commit('update', {
        name,
        scope: false,
      });
    },

    toggleModal({commit}: any, name: string) {
      commit('toggle', name);
    },
  },
};
